import permissionTree from './permissionTree'

//左边菜单
const LEFT_MENU = permissionTree.BASE_TREE
// const LEFT_MENU = [
//   {
//     'name': '仪表盘',
//     'path': '/',
//     'index': '1-1',
//     'icon': require('@/assets/images/dashboard_nor@2x.png'),
//     'children': [
//       {
//         'name': '仪表盘',
//         'path': '/',
//       }
//     ]
//   },
//   {
//     'name': '平台管理',
//     'index': '1-2',
//     'icon': require('@/assets/images/pm_nor@2x.png'),
//     'children': [
//       {
//         'name': '商户管理',
//         'path': '/institution',
//         'children': [
//           {
//             'name': '新建商户',
//             'path': '/newInstitution',
//           },
//           {
//             'name': '商户详情',
//             'path': '/institutionDetail',
//             'isquery': true
//           }
//         ]
//       },
//       {
//         'name': '机构管理',
//         'path': '/merchant',
//         'isquery': true
//       }
//     ]
//   },
//   {
//     'name': '用户中心',
//     'index': '1-5',
//     'children': [
//       {
//         'name': '用户管理',
//         'path': '/user',
//         'children': [{
//           'path': '/userDetail',
//           'name': '详情',
//           'isquery': true, //在面包屑导航跳转中需要参数则设置为true
//           'children': [
//             {
//               'name': '血压详情',
//               'path': '/bloodPressure'
//             },
//             {
//               'name': 'HRV详情',
//               'path': '/hrv'
//             },
//             {
//               'name': '血氧详情',
//               'path': '/bloodOx'
//             },
//             {
//               'name': '心率详情',
//               'path': '/heartRate'
//             }, {
//               'name': '运动详情',
//               'path': '/sport'
//             }, {
//               'name': '步数详情',
//               'path': '/step'
//             }, {
//               'name': '热量详情',
//               'path': '/heat'
//             }, {
//               'name': '睡眠详情',
//               'path': '/sleep'
//             }, {
//               'name': '体重详情',
//               'path': '/weight'
//             }, {
//               'name': '压力详情',
//               'path': '/pressure'
//             }
//           ]
//         }
//         ]
//       },
//       {
//         'name': '会员中心',
//         'path': '/vipCenter'
//       },
//       {
//         'name': '兑换码管理',
//         'path': '/redeem'
//       },
//       // {
//       //   'name': '用户反馈',
//       //   'path': '/feedback',
//       //   'children':[
//       //     {
//       //       'path':'/feedbackDetail',
//       //       'name':'反馈详情',
//       //     'isquery': true
//       //     }
//       //   ]
//       // }
//       // {
//       //   'name': '用户分布',
//       //   'path': '/distribution',
//       // },
//     ],
//     'icon': require('@/assets/images/usercenter_nor@2x.png')
//   },
//   {
//     'name': '设备管理',
//     'index': '1-4',
//     'children': [

//       {
//         'name': '设备列表',
//         'path': '/dev',
//         'children': [
//           {
//             'name': '查看设备',
//             'path': '/devDetail',
//           }
//         ]
//       },
//       {
//         'name': '固件管理',
//         'path': '/ota',
//         'children': [
//           {
//             'name': '固件详情',
//             'path': '/project',
//           },
//           {
//             'name': '项目详情',
//             'path': '/otaList',
//           }
//         ]
//       },
//       {
//         'name': '表盘管理',
//         'path': '/dial',
//       }
//     ],
//     'icon': require('@/assets/images/devicemanage_nor@2x.png')
//   },
//   {
//     'name': '售后中心',
//     'index': '1-8',
//     'icon': require('@/assets/images/callcenter_nor@2x.png'),
//     'children': [{
//       'name': '售后管理',
//       'path': '/feedback',
//       'children': [
//         {
//           'path': '/feedbackDetail',
//           'name': '反馈详情',

//           'isquery': true


//         }
//       ]
//     }]
//   },
//   {
//     'name': '客服中心',
//     'index': '1-3',
//     'icon': require('@/assets/images/callcenter_nor@2x.png'),
//     'children': [{
//       'name': '用户反馈',
//       'path': '/feedback',
//       'children': [
//         {
//           'path': '/feedbackDetail',
//           'name': '反馈详情',

//           'isquery': true


//         }
//       ]
//     }]
//   },
//   // {
//   //   'name': '数据统计',
//   //   'index': '1-7',
//   //   'children': [
//   //     {
//   //       'name': '数据统计',
//   //     }

//   //     // {
//   //     //   'name': '原始数据',
//   //     //   'path': '/rawData',
//   //     //   // 'children': [{
//   //     //   //   'path': '/rawData',
//   //     //   //   'name': '原始数据'
//   //     //   // }]

//   //     // },


//   //   ],
//   //   'icon': require('@/assets/images/datastatistics_nor@2x.png')
//   // },
//   {
//     'name': '系统管理',
//     'index': '1-6',
//     'children': [
//       {
//         'name': '账号管理',
//         'path': '/member',
//       },
//     ],
//     'icon': require('@/assets/images/systemmanage_nor@2x.png')
//   },


// ]
//OTA项目表单头部
const PROJECT_HEADER = [
  {
    'label': '项目编号',
    'prop': 'number'
  },
  {
    'label': '项目名称',
    'prop': 'name'
  },
  {
    'label': '项目关联编号',
    'prop': 'bandCode'
  },
  {
    'label': 'OTA版本号',
    'prop': 'otaVersion'
  },
  {
    'label': '更新时间',
    'prop': 'last_modify_time'
  }
]

//用户管理表单头部
const USER_MANAGE_HEADER = [
  {
    'label': 'ID',
    'prop': 'id'
  },
  {
    'label': '用户名',
    'prop': 'UserName'
  },
  {
    'label': '手机号',
    'prop': 'Mobile'
  },
  {
    'label': '邮箱',
    'prop': 'Email'
  },
  {
    'label': '性别',
    'prop': 'Gender'
  },
  {
    'label': '注册时间',
    'prop': 'CreateTime'
  },
  {
    'label': '状态',
    'prop': 'Status'
  }
]

//用户管理表单头部
const OTA_LIST_HEADER = [
  // {
  //   'label': '版本号',
  //   'prop': 'version'
  // },
  {
    'label': '文件名',
    'prop': 'fileName'
  },
  {
    'label': '上传人',
    'prop': 'uploadUser'
  },
  {
    'label': '上传时间',
    'prop': 'uploadTime'
  },
  {
    'label': '文件大小',
    'prop': 'fileSize'
  }, {
    'label': 'md5',
    'prop': 'validation'
  }
]

// 表盘管理表单头部
const DIAL_LIST_HEADER = [
  {
    'label': '表盘名称',
    'prop': 'name'
  },
  {
    'label': '文件名',
    'prop': 'fileName'
  },
  {
    'label': '更新时间',
    'prop': 'lastModifyTime'
  },
]

//App管理表单头部
const APP_LIST_HEADER = [
  {
    'label': 'App名',
    'prop': 'name'
  },
  {
    'label': '平台',
    'prop': 'platform'
  },
  {
    'label': '更新时间',
    'prop': 'updateTime'
  },
]

//App管理表单头部
const APP_VERSION_LIST_HEADER = [
  {
    'label': '版本号',
    'prop': 'version'
  },
  {
    'label': '更新内容',
    'prop': 'description'
  },
  {
    'label': '是否强制更新',
    'prop': 'forceUpdate'
  },
]
export default {
  LEFT_MENU,
  PROJECT_HEADER,
  USER_MANAGE_HEADER,
  OTA_LIST_HEADER,
  DIAL_LIST_HEADER,
  APP_LIST_HEADER,
  APP_VERSION_LIST_HEADER
}
